// extracted by mini-css-extract-plugin
module.exports = {"checkInputBox":"CheckBoxInput-module--checkInputBox--3aQps","inputBox":"CheckBoxInput-module--inputBox--3z32N"};